<mat-card-content class="hideForPrint">
  <div class="flex gap-4 justify-around">

    <div class="w-1/5">
      <h2 class="mat-h2">Choose report</h2>
      <div class="flex flex-col gap-2 my-4">
        <button class="w-full choose-report-button" [ngClass]="{ 'choose-report-button--selected': reportButtonsState['territoryReview'] }" [disabled]="isButtonDisabled([UserAccessLevel.KAM, UserAccessLevel.Sales])" type="button" color="primary" mat-flat-button (click)="selectTerritoryReview()">Territory Review</button>
        <button class="w-full choose-report-button" [ngClass]="{ 'choose-report-button--selected': reportButtonsState['salesLeaderReview'] }" [disabled]="isButtonDisabled([UserAccessLevel.Sales])" type="button" color="primary" mat-flat-button (click)="selectSalesLeaderReview()">Sales Leader Review</button>
        <button class="w-full choose-report-button" [ngClass]="{ 'choose-report-button--selected': reportButtonsState['marketingReview'] }" [disabled]="isButtonDisabled([UserAccessLevel.Marketing])" type="button" color="primary" mat-flat-button (click)="selectMarketingReview()">Marketing Review</button>
      </div>
    </div>

    <div class="w-1/3">
      <h2 class="mat-h2">Filters</h2>

      <div class="flex  mt-4">
        <app-region-select [regions]="countries" [regionsFiltered]="countriesFiltered" [selectedRegions]="selectedCountriesFC"></app-region-select>
        &nbsp;
        <mat-form-field [ngClass]="{ hidden: selectedReport === 'salesLeaderReview' || selectedReport === 'marketingReview' }" appearance="fill" class="w-full">
          <mat-label>Regions</mat-label>
          <mat-select [formControl]="regionsFormControl" (selectionChange)="setSelectedRegions($event)">
            <mat-option *ngFor="let region of regions;" [value]="region.id">{{ region.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    <div class="w-1/3"></div>

  </div>
</mat-card-content>

<div class="flex mt-4 justify-end hideForPrint">
  <button mat-flat-button color="primary" [disabled]="!generateReportButtonState" (click)="generateReport()">
    <span>Generate report</span>
  </button>
</div>

<!-- Territory review -->
<ng-container *ngIf="selectedReport === 'territoryReview' && generateReportButtonState === false">
  <br><br>
  <div *ngIf="closestSalesDate" class="date">Date: {{ closestSalesDate.month }}/{{ closestSalesDate.year }}</div>

  <div class="download">
    <button *ngIf="getPharmacyDataUrl()" mat-flat-button color="accent" (click)="location.href=getPharmacyDataUrl()"><span>Download pharmacy data</span></button>
    <button *ngIf="getBrickDataUrl()" mat-flat-button color="accent" (click)="location.href=getBrickDataUrl()"><span>Download brick data</span></button>
  </div>


  <div class="twoColsContainer">
    <div class="column">
      <app-market-and-patient-share [project]="project"></app-market-and-patient-share>
      <app-accounts [projectId]="projectId"></app-accounts>
    </div>
    <div class="column">
      <app-sales-in-pack [project]="project"></app-sales-in-pack>
      <app-sales-momentum [project]="project" [rowsToShow]="Number.POSITIVE_INFINITY"></app-sales-momentum>
    </div>
  </div>
</ng-container>

<!-- Sales leader report -->
<ng-container *ngIf="selectedReport === 'salesLeaderReview' && generateReportButtonState === false">
  <br><br>
  <div *ngIf="closestSalesDate" class="date">Date: {{ closestSalesDate.month }}/{{ closestSalesDate.year }}</div>

  <div class="twoColsContainer">
    <div class="column">
      <app-current-business [project]="project"></app-current-business>
    </div>
    <div class="column"></div>
  </div>
  <app-kam-leaderboard [project]="project"></app-kam-leaderboard>
  <app-sales-momentum [project]="project" [rowsToShow]="Number.POSITIVE_INFINITY" [showTerritory]="true"></app-sales-momentum>
  <app-account-leaderboard [project]="project"></app-account-leaderboard>
  <app-treatment-used [project]="project"></app-treatment-used>
</ng-container>

<!-- Marketing review -->
<ng-container *ngIf="selectedReport === 'marketingReview' && generateReportButtonState === false">
  <br><br>
  <div *ngIf="closestSalesDate" class="date">Date: {{ closestSalesDate.month }}/{{ closestSalesDate.year }}</div>

  <div class="twoColsContainer">
    <div class="column">
      <app-current-business [project]="project"></app-current-business>
    </div>
    <div class="column">
      <app-sales-momentum [project]="project" [rowsToShow]="Number.POSITIVE_INFINITY"></app-sales-momentum>
    </div>
  </div>
  <div class="threeColsContainer">
    <div class="column">
      <app-chart-treatment-goals [project]="project"></app-chart-treatment-goals>
    </div>
    <div class="column">
      <app-chart-treatment-used [project]="project"></app-chart-treatment-used>
    </div>
    <div class="column">
      <app-chart-patients [project]="project"></app-chart-patients>
    </div>
  </div>
  <br><br><br>
</ng-container>



